export class TvShow {
  constructor() {}

  tvShowId: string;
  name: string;
  picture: string;
  detailsPicture: string;
  releaseYear: number;
  rating: string;
  description: string;
  isPartOfCategory: boolean;
  categoryTvShowId: string;
  isPartOfHomeScreenGroup: boolean;
  homeScreenGroupTvShowId: string;
  userRating: string;
  ratingsCount: string;
  watchProgress: any;
  watchers: any;
  videoUrl: any;
  premiumStatus: any;
}



// WEBPACK FOOTER //
// ./src/data/TvShow.ts